import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getFlightRateCodesSuccess, getFlightRateCodesRequest } from '../../slices/user';

function* getFlightRateCodesWorker() {
  try {
    const { flightRateCodes, loaded } = yield select((store) => store.user);

    if (loaded && !flightRateCodes) {
      const url = 'users/agencyNegotiatedFlightFareCodes';
      const config = {
        method: 'GET',
        url,
      };
      const { data } = yield call(axios, config);
      yield put(getFlightRateCodesSuccess(data));
    }
  } catch (error) {
    yield put(getFlightRateCodesSuccess());
    console.error(error);
  }
}

function* getFlightRateCodesWatcher() {
  yield takeLatest(getFlightRateCodesRequest.toString(), getFlightRateCodesWorker);
}

export default getFlightRateCodesWatcher;
